import React, { useState, useEffect, useContext } from "react";
import { Drawer } from "../../../Widgets";
import WebMyAccountProvider from "../../../Provider/WebMyAccountProvider";
import styled from "styled-components";
import defaultImg from "../../../Assets/Images/pro.png";
import { DeleteOutlined } from "@ant-design/icons";
import { Link } from "react-router-dom";
import CartContext from "../../../Provider/CartProvider";
import { Empty, Spin } from "antd";
import saved from "../../../Assets/Images/saved.png";
import { EyeOutlined } from "@ant-design/icons";
import ViewCoupon from "./ViewCoupon";
import { create } from "../../../Api/WebApi";

const CartDrawer = () => {

const [isLoggedIn, setIsLoggedIn] = useState(false);
useEffect(() => {
  const getUserDetails = async () => {
    try {
      const res = await create("myaccount.php?action=getlogincheck");
      if (res?.status === 200 && res?.success === true) {

        if (res && res.data) {
            setIsLoggedIn(true);
          }else{
            setIsLoggedIn(false); 
          }
      } else {
        setIsLoggedIn(false); 
      }
    } catch (err) {
      console.log(err);
    setIsLoggedIn(false); 
    }
  };
  getUserDetails();
}, []);

  const {
    cartDrawer,
    setCartDrawer,
    webLoginPopup,
    setWebLoginPopup,
    setLoginDirect,
  } = useContext(WebMyAccountProvider);
  const {
    cartListLoader,
    cartList,
    deleteCart,
    updateCart,
    // couponApplyLoader,
    // couponRemoveLoader,
    // addCoupon,
    // removeCoupon,
    // couponText,
    // setCouponText,
    // viewCouponPopup,
    // setViewCouponPopup,
  } = useContext(CartContext);
  return (
    <Drawer
      open={cartDrawer}
      onclose={() => setCartDrawer(false)}
      width={450}
      title={"View Cart"}
      body={
        <>
          <ViewCoupon cartlist={cartList?.coupon_list} />
          <CartSection>
            <div className="wrapper1">
              {cartListLoader && (
                <div className="col_1 p_t_30 cart_spin">
                  <Spin />
                </div>
              )}
              <div className="align">
                <div className="left">
                  <div className="cart_grid">
                    {cartList?.items?.length > 0 ? (
                      cartList?.items?.map((e, i) => {
                        const image = e?.product_gallery?.split("|")[0];
                        return (
                          <div className="cart_item" key={i}>
                            <div className="cart_item_left">
                              <img
                                src={
                                  image
                                    ? process.env.REACT_APP_UPLOAD_URL + image
                                    : defaultImg
                                }
                                alt=""
                              />
                              <div>
                                <div>
                                  <h2>{e?.product_name}</h2>
                                  {e?.product_label && (
                                    <div className="tag">
                                      {e?.product_label}
                                    </div>
                                  )}
                                </div>
                                <div className="cart_price">
                                  {e?.sp > 0 && <div>&#x20B9; {e?.sp}</div>}
                                  <div>&#x20B9;{e?.mrp}</div>
                                </div>
                              </div>
                            </div>
                            <div className="cart_item_right">
                              <div>
                                <DeleteOutlined
                                  onClick={() => deleteCart(e?.product_id)}
                                />
                              </div>
                              <div className="p_qty">
                                <button
                                  disabled={e?.quantity == 1}
                                  onClick={() =>
                                    updateCart(
                                      e?.product_id,
                                      e?.quantity == 1 ? null : "minus"
                                    )
                                  }
                                >
                                  -
                                </button>
                                <input
                                  type="number"
                                  disabled
                                  value={e?.quantity || 0}
                                />
                                <button
                                  onClick={() =>
                                    updateCart(e?.product_id, "plus")
                                  }
                                >
                                  +
                                </button>
                              </div>
                            </div>
                          </div>
                        );
                      })
                    ) : (
                      <>
                        {!cartListLoader && (
                          <>
                            {" "}
                            <Empty
                              image={Empty.PRESENTED_IMAGE_SIMPLE}
                              description="Cart is Empty"
                              className=""
                              style={{
                                width: "100%",
                                border: "1px solid #f0f0f0",
                                padding: "50px 20px",
                                borderRadius: "12px",
                                margin: "0",
                              }}
                            />
                            <Link
                              to="/products"
                              title="Continue Shopping"
                              onClick={() => setCartDrawer(!cartDrawer)}
                            >
                              <button className="checkout_btn">
                                Continue Shopping
                              </button>
                            </Link>
                          </>
                        )}
                      </>
                    )}
                  </div>
                </div>
                {cartList?.items?.length > 0 && (
                  <div className="right">
                    <div className="right_wrap">
                      {/* <div className="display_coupon">
                        <p>
                          Shop for &#x20B9;{cartList?.coupon?.to_amount} more to
                          apply {cartList?.coupon?.discount_persentage}% off
                          coupon <b>{cartList?.coupon?.coupon_code}</b>
                        </p>
                      </div> */}
                      {/* <div className="apply_coppon">
                        <div
                          onClick={() => setViewCouponPopup(!viewCouponPopup)}
                          className="apply_coppon_1"
                        >
                          <p>
                            <EyeOutlined />
                            View Coupon
                          </p>
                        </div>
                        <input
                          type="text"
                          placeholder="Enter Coupon Code"
                          value={couponText}
                          disabled={cartList?.g_total?.coupon_apply == 1}
                          onChange={(e) => setCouponText(e.target.value)}
                        />
                        {cartList?.g_total?.coupon_apply == 0 ? (
                          <button onClick={() => addCoupon(couponText)}>
                            {couponApplyLoader ? <Spin /> : "Apply"}
                          </button>
                        ) : (
                          <button onClick={() => removeCoupon()}>
                            {couponRemoveLoader ? <Spin /> : "Remove"}
                          </button>
                        )}
                      </div> */}
                      <table>
                        <tbody>
                          <tr>
                            <td>Subtotal</td>
                            <td>
                              {cartList?.g_total?.savings > 0 && (
                                <p className="savings_text">
                                  &#x20B9;
                                  {cartList?.g_total?.savings +
                                    cartList?.g_total?.total || 0}
                                </p>
                              )}
                              <p className="savings_text1">
                                &#x20B9;{cartList?.g_total?.total || 0}
                              </p>
                            </td>
                          </tr>
                          <tr>
                            <td>Discount</td>
                            <td>
                              {cartList?.g_total?.delivery_chargesave > 0 && (
                                <p className="savings_text"></p>
                              )}
                              <p className="savings_text1">
                                - &#x20B9;
                                {cartList?.g_total?.discount || 0}
                              </p>
                            </td>
                          </tr>
                          <tr>
                            <td>Shipping Charge</td>
                            <td>
                              {cartList?.g_total?.delivery_chargesave > 0 && (
                                <p className="savings_text">
                                  &#x20B9;
                                  {cartList?.g_total?.delivery_chargesave || 0}
                                </p>
                              )}
                              <p className="savings_text1">
                                &#x20B9;
                                {cartList?.g_total?.delivery_charge || 0}
                              </p>
                            </td>
                          </tr>
                          <tr>
                            <td colSpan={2}>
                              <p className="savings">
                                <img src={saved} alt="saved" />
                                Total Savings of ₹
                                {cartList?.g_total?.delivery_chargesave +
                                  cartList?.g_total?.savings +
                                  cartList?.g_total?.discount}{" "}
                                From this order
                              </p>
                            </td>
                          </tr>
                          <tr>
                            <td>Grand Total</td>
                            <td>
                              &#x20B9; {cartList?.g_total?.grand_total || 0}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </CartSection>
          {cartList?.items?.length > 0 && (
            <Link
              to={
                isLoggedIn
                  ? "/checkout"
                  : void 0
              }
              className="checkout_btn_align"
              onClick={() => {
                if (isLoggedIn) {
                  setCartDrawer(false);
                } else {
                  setWebLoginPopup(!webLoginPopup);
                  setCartDrawer(false);
                  setLoginDirect("checkout");
                }
              }}
            >
              <button
                className="checkout_btn"
                disabled={cartList?.items?.length < 1}
              >
                Checkout
              </button>
            </Link>
          )}
        </>
      }
    />
  );
};

export default CartDrawer;
const CartSection = styled.section`
  min-height: 250px;
  display: inline-block;
  margin: 0px 0 0px;
  width: 100%;
  position: relative;
  .b_main {
    margin: -60px 0 60px 0;
  }
  .cart_header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    gap: 20px;
  }
  .cart_header img {
    height: 30px;
    cursor: pointer;
  }
  .cart_header h1 {
    font-size: 25px;
    font-family: var(--medium);
  }
  .align {
    display: flex;
    align-items: flex-start;
    width: 100%;
    justify-content: space-between;
    flex-wrap: wrap;
    margin-top: 0px;
    flex-direction: column;
  }
  .left {
    width: 100%;
    display: inline-block;
  }
  .right {
    width: 100%;
    display: inline-block;
    position: sticky;
    top: 70px;
    margin: 20px 0 0 0;
  }
  .cart_grid {
    display: flex;
    flex-direction: column;
    gap: 20px;
  }
  .cart_item {
    border-radius: 12px;
    box-shadow: 0 0 10px rgb(0 0 0 / 10%);
    overflow: hidden;
    display: flex;
    flex-wrap: wrap;
    align-items: stretch;
    justify-content: space-between;
    padding: 20px 20px;
  }
  .cart_item_left {
    display: flex;
    width: 70%;
    align-items: stretch;
    gap: 12px;
  }
  .cart_item_left img {
    height: 100px;
    padding: 6px;
    border: 1px solid #f0f0f0;
    border-radius: 6px;
  }
  .cart_item_left div {
    flex: 1;
    flex-direction: column;
    justify-content: space-between;
    display: flex;
  }
  .cart_item_left div h2 {
    font-size: 16px;
    font-family: var(--regular);
    line-height: 1.4;
  }
  .cart_item_left div .tag {
    font-size: 12px;
    font-family: var(--regular);
    color: #fff;
    background: var(--theme_color);
    padding: 6px 10px 4px 10px;
    width: fit-content;
    border-radius: 5px;
  }
  .cart_item_left div div {
    display: flex;
    flex-direction: column;
    gap: 7px;
  }
  .cart_item_left div .cart_price {
    display: flex;
    gap: 10px;
    flex-direction: row;
    align-items: flex-end;
    justify-content: flex-start;
    flex: auto;
    width: fit-content;
  }
  .cart_item_left div .cart_price div {
    width: fit-content;
    display: inline-block;
    flex: auto;
  }
  .cart_item_left div .cart_price div:nth-child(1) {
    font-size: 18px;
    font-family: var(--medium);
  }
  .cart_item_left div .cart_price div:nth-child(2) {
    font-size: 13px;
    color: #939393;
    font-family: var(--regular);
    text-decoration: line-through;
  }
  .cart_item_right {
    width: 28%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    text-align: end;
  }
  .cart_item_right div:nth-child(1) svg {
    font-size: 22px;
    cursor: pointer;
    color: red;
  }
  .p_qty {
    background: #f0f0f0;
    display: flex;
    border: 1px solid #000;
    border-radius: 5px;
    overflow: hidden;
    width: fit-content;
    margin: 0 0 0 auto;
  }
  .p_qty button {
    width: 45px;
    height: 100%;
    border: 0;
    outline: 0;
    font-size: 30px;
    font-family: var(--regular);
  }
  .p_qty input {
    width: 50px;
    background: transparent;
    border: 0;
    outline: 0;
    text-align: center !important;
    --webkit-appearance: none;
    font-size: 19px;
    font-family: var(--medium);
  }
  .right .right_wrap {
    background: #eef6e4;
    padding: 20px 20px 10px 20px;
    border-radius: 15px;
    width: 100%;
  }
  .right table {
    width: 100%;
  }
  .right table tr td:nth-child(1) {
    font-size: 14px;
    text-align: left;
    font-family: var(--medium);
    padding: 13px 0;
  }
  .right table tr td:nth-child(2) {
    font-size: 14px;
    text-align: right;
    font-family: var(--medium);
    padding: 10px 0;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 10px;
  }
  .right table tr td:nth-child(2) p.savings_text {
    color: #939393;
    font-size: 12px;
    font-family: var(--regular);
    text-decoration: line-through;
  }
  .right table tr td:nth-child(2) p.savings_text1 {
    font-size: 15px;
    text-align: right;
    font-family: var(--medium);
  }
  .right table tr:last-child td {
    border-top: 1px solid #d9d9d9;
    padding-top: 24px;
  }

  .apply_coppon {
    display: flex;
    gap: 10px;
    width: 100%;
    margin-bottom: 30px;
  }
  .apply_coppon input {
    flex: 1;
    width: 100%;
    padding: 15px 10px 11px 10px;
    border-radius: 5px;
    border: 1px solid #000;
    background: transparent;
    outline: none;
  }
  .apply_coppon button {
    background: #000;
    border-radius: 35px;
    border: 0;
    color: #fff;
    padding: 0 20px;
    width: 90px;
  }
  .cart_spin {
    position: absolute;
    width: 100%;
    justify-content: center;
    display: flex;
    align-items: center;
    z-index: 1;
    top: 55px;
    left: 0;
  }

  .cart_item {
    padding: 15px 10px;
    position: relative;
  }
  .cart_item_left img {
    height: 55px;
  }
  .cart_item_left div h2 {
    font-size: 14px;
  }
  .cart_item_left div {
    display: flex;
    flex-direction: column;
    gap: 9px;
  }
  .cart_item_left div .cart_price div:nth-child(1) {
    font-size: 15px;
  }
  .cart_item_left div .cart_price div:nth-child(2) {
    font-size: 11px;
  }
  .p_qty button {
    width: 35px;
    font-size: 25px;
  }
  .p_qty input {
    width: 40px;
    font-size: 16px;
  }
  .cart_item_left {
    width: 100%;
    padding-right: 45px;
  }
  .cart_item_right {
    width: 100%;
    margin-top: 10px;
  }
  .cart_item_right div:nth-child(1) {
    position: absolute;
    top: 8px;
    right: 8px;
    padding: 5px 10px;
    font-size: 10px;
  }
  .cart_item_left div .tag {
    font-size: 9px;
  }
  .right .right_wrap .apply_coppon {
    flex-direction: column;
    gap: 15px;
  }
  .apply_coppon button {
    padding: 15px 20px 12px;
    width: 100%;
  }

  @media screen and (max-width: 480px) {
    .ant-drawer .ant-drawer-content-wrapper {
      max-width: 87vw !important;
    }
    .cart_item_left img {
      height: 45px;
      padding: 5px;
    }
    .cart_item_left div h2 {
      font-size: 13px;
    }
    .cart_item_left {
      gap: 12px;
    }
  }
`;
